import { Component } from '@angular/core';

@Component({
    selector: 'app-upgrade',
    templateUrl: './upgrade.component.html',
    standalone: false
})
export class UpgradeComponent { }
